<template>
  <div class="panel-block">
    <span class="has-text-grey has-text-weight-bold">{{ printDocument?.pageNumbers ? printDocument?.pageNumbers[0]: '' }}</span>&nbsp;
    <!-- <span class="has-text-grey has-text-weight-bold">{{ (printDocument?.pageNumbers ?? []).filter(x => x != null).join(',') }}</span>&nbsp; -->
    <input
      type="checkbox"
      :value="article.uuid"
      ref="rolesSelected"
      @change="onSelectionChange"
    >&nbsp;
    <label
      style="width: 100%;cursor: pointer;"
      :class="{'is-active':(article.uuid === activeArticle?.uuid), 'has-background-warning': (article.uuid === activeArticle?.uuid)}"
      @click="selectActiveArticles(article)"
    >
      <div class="content">
        <span class="is-size-7 has-text-weight-bold">{{ article.storyName }}</span>
        <br>
      </div>
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'IssueSidebar',
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      printDocument: null,
      rolesSelected: '',
      xml_articleName: '',
      xml_summary: '',
      xml_publicationName: '',
      xml_byline: '',
      xml_text: ''
    }
  },
  mounted () {
    this.printDocument = this.article.printDocuments?.[0] ?? null
    this.display_article_xml_toc_content()
  },
  methods: {
    onSelectionChange () {
      const checked = this.$refs.rolesSelected && this.$refs.rolesSelected.checked
      if (checked) {
        this.addSelectedArticles()
      } else {
        this.removeSelectedArticles()
      }
    },
    addSelectedArticles () {
      this.$store.commit('addSelectedArticle', this.article)
      this.selectActiveArticles(this.article)
    },
    removeSelectedArticles () {
      this.$store.commit('removeSelectedArticle', this.article)
      this.$store.commit('setActiveArticle', null)
    },
    selectActiveArticles () {
      this.$store.commit('setActiveArticle', this.article)
    },
    display_article_xml_toc_content () {
      this.xml_summary = ''
      if (!this.printDocument?.xml) {
        return
      }
      const parser = new DOMParser()
      const doc = parser.parseFromString(this.printDocument.xml, 'text/xml')
      const docbody = doc.getElementsByTagName('body')
      try {
        this.xml_articleName = doc.getElementsByTagName('dc:title')[0].childNodes[0].nodeValue
        this.xml_summary = docbody[0].getElementsByTagName('p')[0].childNodes[0].nodeValue
      } catch (e) {
        // TOC preview is best-effort
      }
    }
  },
  computed: {
    ...mapState(['activeArticle', 'selectedArticles'])
  }
}
</script>

<style scoped>
  .has-background-warning {
    background-color: hsl(54, 90%, 60%, 0.41) !important;
  }
</style>
